// ✅ src/lib/notify.js
import { db } from "./firebase";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";

function safe(v) {
  return String(v ?? "").trim();
}

/**
 * Create a notification:
 * notifications/{toUid}/items/{autoId}
 */
export async function createNotification(toUid, payload) {
  const uid = safe(toUid);
  if (!uid) return;

  const type = safe(payload?.type) || "SYSTEM";
  const title = safe(payload?.title) || "Notification";
  const message = safe(payload?.message) || "";
  const data = payload?.data && typeof payload.data === "object" ? payload.data : {};

  await addDoc(collection(db, "notifications", uid, "items"), {
    type,
    title,
    message,
    data,              // optional: route, matchId, fromUid etc.
    read: false,
    createdAt: serverTimestamp(),
  });
}
